<script>
import InputText from '@/components/InputText.vue';

/**
 * @description Поле ввода ИИН.
 * @type {Vue}
 */
export default {
  name: 'InputIin',
  props: {
    /**
     * @description Опциональный ввод.
     */
    optional: {
      default: () => true,
      type: Boolean,
    },
    /**
     * @description Заполнитель.
     */
    placeholder: {
      default: () => 'ИИН',
      required: false,
      type: String,
    },
    /**
     * @description Заголовок.
     */
    title: {
      default: () => 'ИИН',
      required: false,
      type: String,
    },
    /**
     * @description Значение.
     */
    value: {
      required: true,
      type: String,
    },
    /**
     * @description Нарушения.
     */
    violations: {
      default: () => [],
      required: false,
      type: Array,
    },
  },
  render(createElement) {
    return createElement(InputText, {
      directives: [
        {
          name: 'facade',
          value: this.$options.iinMask,
        },
      ],
      on: {
        input: (updatedValue) => this.$emit('input', updatedValue),
        invalid: (...args) => this.$emit('invalid', ...args),
      },
      props: {
        pattern: this.$options.iinPattern,
        placeholder: this.placeholder,
        required: !this.optional,
        title: this.title,
        value: this.value,
        violations: this.violations,
      },
    });
  },
  iinMask: '############',
  iinPattern: '^[0-9]{12}$',
};
</script>
